// extracted by mini-css-extract-plugin
module.exports = {"Kicker":"Kicker_Kicker___NgTB","Kicker_kickerFirst":"Kicker_Kicker_kickerFirst__PRiRw","Kicker_kickerSecond":"Kicker_Kicker_kickerSecond__hZRU1"};